import MainLayout from "../layouts/main-layout/MainLayout";
import ElectricBill from "../pages/bill/ElectricBill";
import WaterBill from "../pages/bill/WaterBill";
import ChangePassword from "../pages/change-pass/ChangePassword";
import Contract from "../pages/contract/Contract";
import Dashboard from "../pages/dashboard/Dashboard";
import Profile from "../pages/profile/Profile";
import MobileTopup from "../pages/topup/MobileTopup";
import Transaction from "../pages/transaction-history/Transaction";
import OpenContract from '../pages/contract/OpenContract';
import SetPin from "../pages/pin/SetPin";
import ChangePin from "../pages/pin/ChangePin";
import Transfer from "../pages/transfer/Transfer";
import Transfer247 from "../pages/transfer/Transfer247";
import Intrabank from "../pages/transfer/Intrabank";
import UsageLimiterPage from "../pages/usage-limiter/UsageLimiter";

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'user',
      children: [
        {
          path: 'change-pass',
          element: <ChangePassword />
        },
        {
          path: 'profile',
          element: <Profile />
        }
      ]
    },
    {
      path: 'bill',
      children: [
        {
          path: 'electric',
          element: <ElectricBill />
        },
        {
          path: 'water',
          element: <WaterBill />
        }
      ]
    },
    {
      path: 'topup',
      children: [
        {
          path: 'mobile',
          element: <MobileTopup />
        }
      ]
    },
    {
      path: 'transaction',
      children: [
        {
          path: 'history',
          element: <Transaction />
        }
      ]
    },
    {
      path: 'contract',
      children: [
        {
          path: '',
          element: <Contract />
        },
        {
          path: 'new',
          element: <OpenContract />
        },
        {
          path: 'set/pin',
          element: <SetPin />
        },
        {
          path: 'change/pin',
          element: <ChangePin />
        },
        {
          path: 'transfer',
          element: <Transfer />
        },
        {
          path: 'transfer247',
          element: <Transfer247 />
        },
        {
          path: 'intrabank',
          element: <Intrabank />
        },
        {
          path: 'usage-limiter',
          element: <UsageLimiterPage />
        }
      ]
    },
  ]
};

export default MainRoutes